export const Base64 = {
  _Rixits: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-',
  fromNumber: function (number) {
    if (isNaN(Number(number)) || number === null || number === Number.POSITIVE_INFINITY)
      throw 'The input is not valid'
    if (number < 0) throw "Can't represent negative numbers now"

    var rixit

    var residual = Math.floor(number)
    var result = ''
    while (residual != 0) {
      rixit = residual % 64
      result = this._Rixits.charAt(rixit) + result
      residual = Math.floor(residual / 64)
    }
    return result
  },
  toNumber: function (rixits) {
    var result = 0
    rixits = rixits.split('')
    for (var e = 0; e < rixits.length; e++) {
      result = result * 64 + this._Rixits.indexOf(rixits[e])
    }
    return result
  },
}

export const sha256 = async (message) => {
  const msgBuffer = new TextEncoder().encode(message)

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // convert bytes to hex string
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
